var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooleanVar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "20.29 13.29 15 18.59 12.71 16.29 11.29 17.71 15 21.41 21.71 14.71 20.29 13.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.71 10.71 6.5 7.91 9.29 10.71 10.71 9.29 7.91 6.5 10.71 3.71 9.29 2.29 6.5 5.09 3.71 2.29 2.29 3.71 5.09 6.5 2.29 9.29 3.71 10.71"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.69,
    y: 11,
    width: 22.63,
    height: 2,
    transform: "translate(-4.97 12) rotate(-45)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooleanVar);
export default __webpack_public_path__ + "static/media/boolean_var.7fbdde30cba68b82aadb5ad33ef22d44.svg";
export { ForwardRef as ReactComponent };